import { POST_CARD_APPLY_ERROR, POST_CARD_APPLY_START, POST_CARD_APPLY_SUCCESS } from '../../types';

export default function post_card_apply(state, action) {
  switch (action.type) {
    case POST_CARD_APPLY_START:
      return { ...state };
    case POST_CARD_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case POST_CARD_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}